"use client";

import type { ReactNode } from 'react';
import { useRef } from 'react';
import { useGlobalDropHandler } from '@/kernel/useGlobalDropHandler';
import { useKernelStore } from '@/kernel/kernelStores';
import { selectActiveSessionProjectIdFromInventoryState } from '#lib/leasing/chat-session-project-focus';

interface AppInputLayerProps {
  children: ReactNode;
}

export default function AppInputLayer({ children }: AppInputLayerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const projectId = useKernelStore(selectActiveSessionProjectIdFromInventoryState) ?? '';

  useGlobalDropHandler({
    containerRef,
    projectId,
  });

  return (
    <div ref={containerRef} className="relative h-full w-full">
      {children}
    </div>
  );
}
